import { useQuery } from "@tanstack/react-query";
import { useEmbeddyCrockerApiClient } from "../../hooks/useApiClient";
import { titleCase } from "../../utils";
import {ImageCaptionProps} from "../gallery/types";

const AIImageCaption = ({ imageSrc }: ImageCaptionProps) => {
  const api = useEmbeddyCrockerApiClient();
  const { data: metadata } = useQuery({
    queryKey: ["ai-image-search-metadata", imageSrc],
    queryFn: async () =>
      api.imageEmbedding
        .getImageMetadata({ url: imageSrc })
        .then((m) => m.items[0]),
    throwOnError: true,
    refetchOnWindowFocus: false,
  });
  if (!metadata) {
    return <></>;
  }
  const styles = "text-sm text-grey-300 overflow-hidden truncate w-full";

  const cruiseId = metadata?.extra?.cruise_external_id;
  const rovDeploymentId = metadata?.extra?.deployment_external_id;

  if (cruiseId && rovDeploymentId) {
    return (
      <p className={styles}>
        {cruiseId} | {rovDeploymentId}
      </p>
    );
  }

  const genusSpecies = metadata.extra?.path
    ?.match(/genus=([^/]+)\/species=([^/]+)/)
    .slice(1);
  if (genusSpecies) {
    return (
      <i className={styles}>
        {titleCase(genusSpecies[0])} {genusSpecies[1].toLowerCase()}
      </i>
    );
  }

  return <p className={styles}>{metadata.url}</p>;
};

export default AIImageCaption;
